export const translationsV2 = [
    {
        country: "Germany",
        language: "DE",
        translations: {
            buttonBackText: 'Zurück',
            buttonHelpText: 'Hilfe',
            buttonNextText: 'Weiter',
            buttonSubmitText: 'Einreichen',
            emailLabel: 'Email',
            nameLabel: 'Name',
            telephoneLabel: 'Telefon',
            calCompMsgSelectDateError: 'Du musst ein Datum auswählen.',
            calCompMsgGettingDates: 'Termine bekommen...',
            calCompMsgNoMonday1: 'Wenn keiner der Termine passt, verwende bitte die Pfeiltasten neben dem Kalender,',
            calCompMsgNoMonday2: 'um die Verfügbarkeit in den nächsten Monaten zu überprüfen',
            calCompMsgPrior: 'Bevor du ein Datum auswählst, bespreche dies mit deinem Manager und über mögliche Auswirkungen des Upgrade-Prozesses und Arbeitsabläufe',
            calCompMsgReceive: 'Sobald du das neue Gerät erhältst und die Umstellung in deinem Standort beendet hast, gebe bitte das alte Gerät bis zum Ende des Arbeitstages beim Ansprechpartner deiner Niederlassung ab.',
            calCompMsgSelectedDate: 'Ausgewähltes Datum',
            calCompMsgSelect: 'Bitte wähle ein Datum aus dem Kalender rechts, um den Upgrade-Tag festzulegen',
            calCompTitle: 'Upgrade-Woche',
            optOutBack: 'Zurück zur Registrierungsseite',
            optOutLine1: 'Wenn du keinen Ersatzcomputer erhalten möchtest, fülle bitte das untenstehende Formular aus und klicken auf Weiter, um dich abzumelden.',
            optOutNote: 'Hinweis: Wenn du diese Option auswählst, nimmst du nicht mehr am Auffrischungsprogramm teil: du erhältst keine Auffrischungs-E-Mails mehr und kannst nicht mehr auf die Auffrischungswebsite zugreifen',
            optOutReviewLine1: 'Du hast dich aus dem Aktualisierungsprogramm abgemeldet. - Weitere Details findest du unten. ',
            optOutReviewLine2: 'Wenn du Fragen hast, sende bitte eine E-Mail an',
            optOutReviewLine3: 'Bitte überprüfe deine Antworten',
            optOutReviewCommentsLabel: 'Abmeldungskommentare',
            optOutReviewUserLoginLabel: 'Benutzername',
            optOutReason: 'Bitte gib deinen Grund für die Abmeldung an',
            optOutRequiredField: 'Erforderliches Feld',
            optOutTitle: 'Abmeldeseite',
            optOutConfirmationThankYou: 'Vielen Dank!',
            optOutConfirmationMessage1: 'Du hast dich erfolgreich gegen ein Upgrade deines Computers entschieden. Du erhältst in Kürze eine Bestätigungs-E-Mail.',
            optOutConfirmationMessage2: 'Bei Fragen wende dich bitte an:',
            optOutErrorMessage: 'Fehler: Sie müssen alle Pflichtfelder ausfüllen.',
            reviewAccountLoginLabel: 'Benutzername',
            reviewComputerLabel: 'Computer-Modell',
            reviewDateExceededMessage: 'Fehler: Das von Ihnen ausgewählte Upgrade-Datum ist nicht mehr verfügbar, oder Sie haben kein Upgrade-Datum ausgewählt. Bitte kehren Sie zur Seite „Upgrade-Woche“ zurück und wählen Sie einen verfügbaren Montag aus.',
            reviewDeliveryLabel: 'Lieferadresse',
            reviewEditDeviceLabel: 'Computerauswahl bearbeiten',
            reviewEditUserLabel: 'Benutzerinformationen bearbeiten',
            reviewEditWeekLabel: 'Upgradetag bearbeiten',
            reviewHomeOfficeLabel: 'Niederlassung',
            reviewMessage1: 'Sie sind bereits registriert – Details finden Sie weiter unten.',
            reviewMessage2: 'Wenn Sie umbuchen müssen, klicken Sie auf die Schaltfläche „Hilfe“, um eine E-Mail an die Upgrade-Mailbox zu senden.',
            reviewSelections: 'Bitte überprüfen Sie Ihre Auswahl.',
            reviewUpgradeWeekLabel: 'Upgrade-Tag',

            //#region "Germany" user information
            country: 'Land',
            homeOffice: 'Standort',
            upDETitle: 'Benutzerinformationen',
            next: 'Weiter',
            deliveryLabel: 'Lieferadresse:',
            //#endregion

            //#region "Germany" computer selection
            csTitle: 'Computer-Auswahl',
            csSubtitle: '',
            csComptuerModel: 'Auswahltitel',
            csDisplay: 'Bildschrim',
            csProcessor: 'Prozessor',
            csRam: 'Arbeitsspeicher',
            csHardDrive: 'Festplatte',
            csPorts: 'Anschlüsse',
            csWeight: 'Gewicht',
            csBatteryLife: 'Akkulaufzeit',
            csErrorMessage: 'Du hast derzeit keine zugelassenen Geräte.',
            csErrorMessage2: 'Bitte kontaktiere das ',
            csSelectionReminder: '*Bitte wähle ein Gerät aus!',
            csBatteryWarning: '**Die Akkulaufzeit hängt von vielen Faktoren ab, darunter Bildschirmhelligkeit, Anwendungen, Funktionen, Energieverwaltung, Akkuzustand und andere Kundenpräferenzen.'
            //#endregion
            
        },
    },
    {
        country: "France",
        language: "FR",
        translations: {
            buttonBackText: 'Retour',
            buttonHelpText: 'aide',
            buttonNextText: 'Suivant',
            buttonSubmitText: 'Soumettre',
            emailLabel: 'Email',
            nameLabel: 'Nom',
            telephoneLabel: 'Téléphone',
            calCompMsgSelectDateError: 'Erreur: Vous devez sélectionner une date',
            calCompMsgGettingDates: 'Obtenir des dates',
            calCompMsgNoMonday1: 'Si aucune des dates ne vous convient, veuillez utiliser les boutons fléchés à côté du calendrier',
            calCompMsgNoMonday2: 'pour vérifier la disponibilité dans les mois suivants',
            calCompMsgPrior: 'Avant de sélectionner une date, consultez votre responsable d\'engagement concernant tout impact potentiel que le processus de mise à niveau pourrait avoir sur vos engagements professionnels',
            calCompMsgReceive: 'Une fois que vous aurez reçu le nouvel appareil et Complété le basculement dans votre agence, veuillez laisser l\'ancien appareil au POC avant l\'End de la journée en cours',
            calCompMsgSelectedDate: 'Date sélectionnée',
            calCompMsgSelect: 'Veuillez sélectionner une date à partir du calendrier à droite pour choisir votre jour de mise à niveau',
            calCompTitle: 'Semaine de mise à niveau',
            optOutBack: 'Retour au site d\'enregistrement',
            optOutLine1: 'Si vous ne souhaitez pas recevoir d\'ordinateur de mise à jour, veuillez remplir le formulaire ci-dessous et le soumettre pour vous désinscrire',
            optOutNote: 'Remarque : En sélectionnant cette option, vous ne participerez plus au programme de rafraîchissement : vous ne recevrez plus d\'e- mails de rafraîchissement et ne pourrez plus accéder au site de rafraîchissement.',
            optOutReviewLine1: 'Vous avez choisi de ne pas participer au programme de rafraîchissement. - Voir ci-dessous pour plus de détails',
            optOutReviewLine2: 'Si vous avez des questions, veuillez envoyer un courriel au',
            optOutReviewLine3: 'Veuillez revoir vos réponses',
            optOutReviewCommentsLabel: 'Commentaires sur l\'exclusion',
            optOutReviewUserLoginLabel: 'Connexion au compte',
            optOutReason: 'Veuillez indiquer la raison de votre désistement',
            optOutRequiredField: 'Champ obligatoire',
            optOutTitle: 'Page d\'exclusion',
            optOutConfirmationThankYou: 'Merci!',
            optOutConfirmationMessage1: 'Vous avez réussi à désactiver la mise à niveau de votre ordinateur. Vous recevrez un e-mail de confirmation sous peu.',
            optOutConfirmationMessage2: 'Si vous avez des questions, veuillez contacter :',
            optOutErrorMessage: 'Erreur : vous devez remplir tous les champs obligatoires.',
            reviewAccountLoginLabel: 'Connexion au compte',
            reviewComputerLabel: 'Modèle informatique',
            reviewDateExceededMessage: "Erreur : la date de mise à niveau que vous avez sélectionnée n'est plus disponible, ou vous n'avez pas sélectionné de date de mise à niveau. Veuillez revenir à la page « Semaine de mise à niveau » et sélectionner un lundi disponible.",
            reviewDeliveryLabel: 'Localisation de livraison',
            reviewEditDeviceLabel: 'Corriger la sélection de l\'ordinateur',
            reviewEditUserLabel: 'Corriger les informations utilisateur',
            reviewEditWeekLabel: 'Corriger le jour de mise à niveau',
            reviewHomeOfficeLabel: 'Localisation du bureau à domicile',
            reviewMessage1: 'Vous êtes déjà inscrit - voir ci-dessous pour plus de détails',
            reviewMessage2: 'Si vous devez annuler ou reporter votre rendez-vous, cliquez sur le bouton Aide pour envoyer un e-mail à la boîte aux lettres des mises à niveau.',
            reviewSelections: 'Veuillez vérifier vos sélections',
            reviewUpgradeWeekLabel: 'Jour de la mise à niveau',

            //#region "French" user information
            country: 'Pays',
            homeOffice: 'Bureau à domicile',
            upDETitle: "Information d'utilisateur",
            next: 'Suivant',
            deliveryLabel: 'Bureau de livraison:',
            //#endregion

            //#region "French" computer selection
            csTitle: "Sélection d'ordinateurs",
            csSubtitle: '',
            csComputerModel: 'Modèle',
            csDisplay: 'Écran',
            csProcessor: 'Processeur',
            csRam: 'Mémoire vive',
            csHardDrive: 'Disque dur',
            csPorts: 'Connexions',
            csWeight: 'Poids',
            csBatteryLife: 'Autonomie de la batterie',
            csErrorMessage: 'vous n\'avez actuellement aucun périphérique autorisé.',
            csErrorMessage2: 'Veuillez contacter ',
            csSelectionReminder: '*Veuillez sélectionner un ordinateur!',
            csBatteryWarning: '**L\'autonomie de la batterie varie en fonction de nombreux facteurs, notamment la luminosité de l\'écran, les applications, les fonctionnalités, la gestion de l\'alimentation, l\'état de la batterie et d\'autres préférences du client.'
            //#endregion
        }
    },
    {
        country: "United States",
        language: "US",
        translations: {
            buttonBackText: 'Back',
            buttonHelpText: 'Help',
            buttonNextText: 'Next',
            buttonSubmitText: 'Submit',
            emailLabel: 'Email',
            nameLabel: 'Name',
            telephoneLabel: 'Telephone',
            calCompMsgSelectDateError: 'Error: You must select a date',
            calCompMsgGettingDates: 'Getting All The Available Dates',
            calCompMsgNoMonday1: 'If there are no Mondays in the current months, please use the ',
            calCompMsgNoMonday2: 'arrow buttons next to the calendar to check for availability in the following months',
            calCompMsgPrior: 'Prior to selecting a date, consult with your engagement manager about any potential impact the upgrade process will have on your work commitments',
            calCompMsgReceive: 'Once you receive the refresh computer and have completed the switchover at your branch, please leave the old computer with the POC by the end of the working day',
            calCompMsgSelectedDate: 'Selected Date',
            calCompMsgSelect: 'Please select a date from the calendar on the right to choose your Upgrade Week',
            calCompTitle: ' Upgrade Week ',
            optOutBack: 'Back to Registration Site',
            optOutLine1: 'If you do NOT wish to receive a refresh computer, please fill out the form below and submit to Opt-out.',
            optOutNote: 'Please Note: By selecting this option, you will no longer be taking part in the refresh program: you will no longer receive refresh emails, and will not be able to access the refresh site.',
            optOutReviewLine1: 'You have Opted-out of the refresh program. - Please see below for details.',
            optOutReviewLine2: 'If you have any questions, please email the',
            optOutReviewLine3: 'Please review your responses',
            optOutReviewCommentsLabel: 'Opt-out Comments',
            optOutReviewUserLoginLabel: 'Account Login',
            optOutReason: 'Please state your reason for opting out',
            optOutRequiredField: 'Required Field',
            optOutTitle: 'Opt-Out',
            optOutConfirmationThankYou: 'Thank you!',
            optOutConfirmationMessage1: 'You have successfully Opted-out from upgrading your computer. You will receive an email confirmation shortly.',
            optOutConfirmationMessage2: 'If you have any questions, please contact:',
            optOutErrorMessage: 'Error: You must complete all required fields.',
            reviewAccountLoginLabel: 'Account Login',
            reviewComputerLabel: 'Computer Model',
            reviewDateExceededMessage: 'Error: The Upgrade Date you have selected is no longer available, or you have not selected an upgrade date. Please go back to the Upgrade Week page and select an available Monday',
            reviewDeliveryLabel: 'Delivery Location',
            reviewEditDeviceLabel: 'Edit Device Selection',
            reviewEditUserLabel: 'Edit User Information',
            reviewEditWeekLabel: 'Edit Upgrade Week',
            reviewHomeOfficeLabel: 'Home Office Location',
            reviewMessage1: 'You are already registered - see below for details',
            reviewMessage2: 'If you need to cancel or reschedule click the Help button to email the Upgrades Mailbox',
            reviewSelections: 'Please review your selections',
            reviewUpgradeWeekLabel: 'Upgrade Week',
            country: 'Country',
            homeOffice: 'Home Office',
            upDETitle: "User Information",
            deliveryLabel: 'Delivery Office:',

            //#region "US" computer selection
            csTitle: 'Computer Selection',
            csSubtitle: '',
            csComptuerModel: 'Model',
            csDisplay: 'Display',
            csProcessor: 'Processor',
            csRam: 'Ram',
            csHardDrive: 'Hard Drive',
            csPorts: 'Ports',
            csWeight: 'Weight',
            csBatteryLife: 'Battery Life',
            csErrorMessage: 'You currently have no allowed devices.',
            csErrorMessage2: 'Please send us an email at',
            csSelectionReminder: '*Please Select a Device!',
            csBatteryWarning: '**Battery life will vary based on many factors including screen brightness, applications, features, power management, battery condition, and other customer preferences.'
            //#endregion
        }
    },
]

// This is a template for adding language support. If placeholder values are prepended with <language>_ it will be easier to see them in the code and the running project.
// Like "DE_back" will be apparent that the back text is a placeholder for DE until the translation string is available.
//country: "United States",
//language: "US",
//translations: {
//    buttonBackText: '',
//    buttonHelpText: '',
//    buttonNextText: '',
//    buttonSubmitText: '',
//    emailLabel: '',
//    nameLabel: '',
//    telephoneLabel: '',
//    calCompMsgSelectDateError: '',
//    calCompMsgGettingDates: '',
//    calCompMsgNoMonday1: '',
//    calCompMsgNoMonday2: '',
//    calCompMsgPrior: '',
//    calCompMsgReceive: '',
//    calCompMsgSelectedDate: '',
//    calCompMsgSelect: '',
//    calCompTitle: '',
//    optOutBack: '',
//    optOutLine1: '',
//    optOutNote: '',
//    optOutReviewLine1: '',
//    optOutReviewLine2: '',
//    optOutReviewLine3: '',
//    optOutReviewCommentsLabel: '',
//    optOutReviewUserLoginLabel: '',
//    optOutReason: '',
//    optOutRequiredField: '',
//    optOutTitle: '',
//    optOutConfirmationMessage: '',
//    reviewAccountLoginLabel: '',
//    reviewComputerLabel: '',
//    reviewDateExceededMessage: '',
//    reviewDeliveryLabel: '',
//    reviewEditDeviceLabel: '',
//    reviewEditUserLabel: '',
//    reviewEditWeekLabel: '',
//    reviewHomeOfficeLabel: '',
//    reviewMessage1: '',
//    reviewMessage2: '',
//    reviewSelections: '',
//    reviewUpgradeWeekLabel: ''
//},